import * as React from "react";
import { forwardRef } from "react";
const SvgTextVerticalAlignTop = (props, ref) => /* @__PURE__ */ React.createElement("svg", { fill: "none", height: 20, viewBox: "0 0 20 20", width: 20, xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "m18 3h-16m8 3v11m-3-8 3-3 3 3", stroke: "#2c2d32", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(SvgTextVerticalAlignTop);
export default ForwardRef;
